import * as types from '../actions/action-types';
import initialState from './initial-state';

export default function registerFormReducer(state = initialState.registerForm, action) {
    switch (action.type) {
        case types.REGISTER_USER_SUCCESS:
            return {
                ...state,
                isRegisterSuccessful: true,
                userName: action.userName,
                userRegistrationMessages: action.userRegistrationMessages
            };
        case types.REGISTER_USER_ERROR:
            return {
                ...state,
                isRegisterSuccessful: false,
                userName: '',
                userRegistrationMessages: action.userRegistrationMessages
            };
        case types.LOAD_REGISTER_FORM_DATA_SUCCESS:
            return {
                ...state,
                isFormLoadSuccessful: true,
                registerFormData: action.registerFormData,
                userRegistrationMessages: []
            };
        case types.LOAD_REGISTER_FORM_DATA_ERROR:
            return {
                ...state,
                isFormLoadSuccessful: false,
                registerFormData: {},
                userRegistrationMessages: []
            };
        case types.RESEND_EMAIL_VERIFICATION_SUCCESS:
            return {
                ...state,
                isResendEmailVerificationSuccessful: true,
                resendEmailVerificationMessages: action.resendEmailVerificationMessages,
            };
        case types.RESEND_EMAIL_VERIFICATION_ERROR:
            return {
                ...state,
                isResendEmailVerificationSuccessful: false,
                resendEmailVerificationMessages: action.resendEmailVerificationMessages,
            };
        case types.RESET_REGISTER_FORM_STATE:
            return initialState.registerForm;
        case types.VERIFY_IF_USER_EMAIL_EXISTS_SUCCESS:
            return {
                ...state,
                isUserEmailAlreadyUsed: false
            };
        case types.VERIFY_IF_USER_EMAIL_EXISTS_ERROR:
            return {
                ...state,
                isUserEmailAlreadyUsed: true
            };
        default:
            return state;
    }
}
